export default __webpack_public_path__ + "static/media/menu.baa9f4c3.svg";